export const investorContactTypes = [
    { id: "free", name: "Free" },
    { id: "paid", name: "Paid" }
];
